export const stylesMode = {
  dark: '[data-mui-color-scheme="dark"] &',
  light: '[data-mui-color-scheme="light"] &',
};

export const mediaQueries = {
  upLg: "@media (min-width:1200px)",
  upMd: "@media (min-width:900px)",
  upSm: "@media (min-width:600px)",
  upXl: "@media (min-width:1536px)",
  upXs: "@media (min-width:0px)",
};
